<script>
  // Example skills and interests array
  const skills = [
    "Python",
    "JavaScript",
    "HTML",
    "CSS",
    "Perl",
    "Bash",
    "MATLAB",
    "C++",
    "C",
    "SQL",
    "Powershell",
    "Git",
    "Bash",
    "MATLAB",
    "Wireshark",
    "MS Office",
    "Google Suite",
    "Putty",
    "Linux",
    "MacOS",
    "Grafana",
  ];

  const interests = [
    "DevOps automation",
    "Robotics",
    "Homelab for VMs",
    "Game servers",
  ];

  // For simplicity, projects are not detailed here. Consider linking to a Projects component or page.
</script>

<div class="about-section">
  <h2>Professional Summary</h2>
  <p>
    My multifaceted skill set makes me akin to a Swiss Army knife in the tech
    industry, adept at tackling a diverse range of challenges with precision and
    adaptability. Whether it's fine-tuning the intricacies of robotics systems
    or streamlining complex remote operations, my approach combines depth of
    knowledge with a breadth of technical agility, ensuring robust and
    innovative solutions in every project I undertake.
  </p>

  <h2>Work Experience</h2>
  <h3>Phantom Auto - Support Engineer</h3>
  <p>Remote / Chicago, IL, 08/2023 - 03/2024</p>

  <h3>Motorola Solutions - Video Systems Engineer</h3>
  <p>Chicago, IL, 12/2021 - 08/2023</p>

  <h3>Interstates - Technology Analyst</h3>
  <p>Sioux Falls, SD, 06/2020 - 07/2021</p>

  <h3>Texas Tech University Health Sciences Center - Network Engineer I</h3>
  <p>Lubbock, TX, 01/2020 - 05/2020</p>

  <h3>Texas Instruments - Product Marketing Engineer</h3>
  <p>Houston, TX, 05/2019 - 08/2019</p>

  <h3>Centerpoint Energy</h3>
  <p>Programmer Analyst, 01/2019 - 05/2019</p>

  <h3>Bazar Solutions - IT Help Desk</h3>
  <p>Lubbock, TX, 08/2018 - 12-2018</p>

  <h3>Senninger Irrigation - Warehouse Associate</h3>
  <p>Lubbock, TX, 07/2017 - 10/2017</p>

  <h3>Trader Joe’s - Crew Member</h3>
  <p>Houston, TX, 10/2014 - 06/2015</p>

  <h3>Chili’s - Dishwasher/Cook</h3>
  <p>Humble, TX, 07/2014 - 10/2014</p>

  <h3>Wayne Electric - Apprentice Electrician</h3>
  <p>Houston, TX, 02/2013 - 02/2014</p>

  <h3>Trader Joe’s - Crew Member</h3>
  <p>Chicago, IL, 10/2011 - 06/2012</p>

  <h3>Burnham Harbor - Dock Hand</h3>
  <p>Remote / South San Francisco, CA, 05/2010 - 08/2010</p>

  <h3>Skills</h3>
  <ul class="skills-list">
    {#each skills as skill}
      <li>{skill}</li>
    {/each}
  </ul>

  <h3>Interests</h3>
  <ul class="interests-list">
    {#each interests as interest}
      <li>{interest}</li>
    {/each}
  </ul>

  <h2>Education</h2>
  <div class="school">
    <h3>Texas Tech University</h3>
    <p class="degree">BS Computer Engineering</p>
    <p class="years">2016-2020</p>
    <p class="details">IEEE Officer</p>
  </div>
</div>

<style>
  .about-section {
    color: #ddd;
    max-width: 800px;
    margin: auto;
    padding: 20px;
  }

  .skills-list,
  .interests-list {
    display: flex;
    flex-wrap: wrap;
    list-style-type: none;
    padding: 0;
  }

  .skills-list li,
  .interests-list li {
    margin-right: 10px;
    background: #333;
    color: #ddd;
    padding: 5px 10px;
    border-radius: 5px;
    margin-bottom: 10px;
  }

  h2,
  h3 {
    color: #00adb5;
  }

  p,
  li {
    color: #bbb;
  }
</style>
